import client from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { Button } from 'components/Button/Button'
import InfoModal from 'components/InfoModal/InfoModal'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { HOME_PATH } from 'paths'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Actions from 'redux/actions'
import { WorkspaceSettings } from 'types'
import Styles from './DeactivateWorkspace.module.scss'
import { useCurrentPlan } from 'hooks/useCurrentPlan'
import { AlertTriangle } from 'blaze-ui/icons'

interface Props {
  workspace?: WorkspaceSettings
  workspaceName?: string
}

export const DeactivateWorkspace = ({ workspace, workspaceName }: Props) => {
  const [deactivateModalVisible, setDeactivateModalVisible] = useState(false)
  const history = useHistory()
  const workspaces = useWorkspaces()
  const dispatch = useDispatch()
  const plan = useCurrentPlan()

  const handleDeactivateWorkspace = () => {
    const isWorkspaceCancelledOrTrialing = !!plan?.data?.cancel_at || ['trialing', 'canceled'].includes(plan?.data?.status || '')

    if (!isWorkspaceCancelledOrTrialing) {
      showErrorMessageToast('Please cancel your existing subscription before deactivating your workspace')
      return
    } else {
      setDeactivateModalVisible(true)
    }
  }

  return (
    <>
      <InfoModal
        onOk={() => {
          if (!workspace) return false

          client.deactivateWorkspace(workspace.key).then((e) => {
            if (e.type === SUCCESS_RESPONSE_TYPE) {
              const newWorkspaces = workspaces.filter((w) => w.id !== workspace.id)
              dispatch(Actions.currentWorkspaceIdSet(newWorkspaces[newWorkspaces.length - 1].id))
              dispatch(Actions.workspacesSet(newWorkspaces))
              history.push(HOME_PATH)
            } else {
              showErrorMessageToast('Something went wrong, please try again later')
            }
          })

          return true
        }}
        okText="Yes, deactivate"
        cancelText="No, cancel"
        title={`Deactivate ${workspaceName ? workspaceName : 'workspace'}`}
        visible={deactivateModalVisible}
        setVisible={setDeactivateModalVisible}
      >
        Are you sure you want to deactivate this workspace? All docs and users will be removed.
      </InfoModal>
      <Button
        className={Styles.deactivateButton}
        size="md"
        variant="secondary"
        onPress={handleDeactivateWorkspace}
        data-testid="deactivate"
        isDisabled={!plan.isFetched}
        frontIcon={AlertTriangle}
      >
        Delete Workspace
      </Button>
    </>
  )
}


